import { Check, CircleAlert, View } from "lucide-react";
import { useState, useEffect } from "react";
import { CustomProperty } from "winslow-core";
import { validateEmail } from "../../uiHelpers";
import { AppCustomPropertyError } from "./AppCustomPropertyError";

type AppCustomPropertyEmailProps = {
    customProperty: CustomProperty;
    data: any;
    disabled: boolean;
    validate: boolean;
    onChange: (label: string, data: any) => void;
}

export const AppCustomPropertyEmail = ({customProperty, data, disabled, validate, onChange} : AppCustomPropertyEmailProps) => {

    const [value, setValue] = useState<string>(data as string || "");

    useEffect(() => {
        onChange(customProperty.label, value);
    }, [value]);

    return (
        <div className="app-custom-property-email">
            {/* <div className="app-custom-property-label">
                {customProperty.label}
            </div> */}
            <div className="app-custom-property-value">
               
                <input 
                    type="text"
                    disabled={disabled}
                    name={customProperty.label}
                    value={value}
                    onChange={(event) => {
                        setValue(event.target.value);
                    }}
                />
                <AppCustomPropertyError 
                    flagRequired={validate && !value && customProperty.required}
                    flagError={!!(validate && value && !validateEmail(value))}
                />
                {/* {validate && !value && customProperty.required &&
                    <AppCustomPropertyError />
                }
                {validate && value && !validateEmail(value) &&
                    <div className="app-employee-record-error">
                        <CircleAlert size={16} color="green"/>
                    </div>
                } */}
            </div>
        </div>
    )
}
